/* eslint-disable */
import React from 'react';
import styled from 'styled-components';
import { Team as TeamIcon } from '../common/icons/icons';
import colors from '../../utils/colors';
import useLocalization from '../../localization/useLocalization';
import { useAppSelector } from '../../store/hooks';
import type { RootState } from '../../store/types';

const Row = styled.div`
    display: flex;
    align-items: center;
    margin-bottom: 12px;
`;

const ReloadButton = styled.button`
    font-size: 14px;
    color: #4550e6;
    font-weight: 600;
    font-family: inherit;
    appearance: none;
    border: none;
    background: none;
    padding: 5px;
    text-transform: uppercase;
    letter-spacing: 1.1px;
`;

const Message = styled.div`
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
`;

const Container = styled.div`
    width: 100%;
    padding: 24px 16px 16px;
    background-color: ${colors.white.basic};
    overflow: hidden;
    border-top: 1px solid ${colors.gray.wild_sand};
`;

export const NoTeamCardBase = (props: { reload: () => void }) => {
    const { reload } = props;
    const localization = useLocalization();
    const asrConfigErrors = useAppSelector((state: RootState) => state.trainer.asrConfigErrors);

    if (!asrConfigErrors || !asrConfigErrors.noTeam) {
        return null;
    }

    return (
        <React.Fragment>
            <Container>
                <Row>
                    <TeamIcon style={{ marginRight: 10, flexShrink: 0 }} />
                    <Message>
                        {localization.getText(`trainer.asr_config_errors.no_team`)}
                    </Message>
                </Row>
                <div style={{ textAlign: 'right' }}>
                    <ReloadButton type="button" onClick={reload}>
                        {localization.getText('trainer.asr_config_error_button')}
                    </ReloadButton>
                </div>
            </Container>
        </React.Fragment>
    );
};

export const NoTeamCard = NoTeamCardBase;
